export enum DataSourceModalType {
  ImportFile = "ImportFile",
  ViewData = "ViewData",
}
